module.exports = __webpack_public_path__ + "static/media/apk_popup_mobile.fc0f8ede.webp";